module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "pl-epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Grief fills the room up of my absent child… ")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King John")]), _vm._v(", Act III, Scene iv, William Shakespeare")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea44d30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Epigraph.vue
// module id = 78
// module chunks = 0